import type { AxiosError } from 'axios';
import axios from '@/js/lib/helper/axios';
import { updateToken } from '@/js/lib/api/v1/update_token';

interface Response {
  message: string;
}

export const resendCode = async (): Promise<Response> => {
  const token = await updateToken();
  try {
    const res = await axios.post('/api/signin/mfa/resend-code', { token });
    return res.data;
  } catch (error) {
    // ネットワークエラーの場合
    if (!error.response) {
      throw new Error('ネットワークエラーが発生しました。インターネット接続を確認してください。', { cause: error });
    }

    throw new Error((error as AxiosError<Response>)?.response?.data?.message || '認証コードの再送信に失敗しました。時間をおいて再度お試しください。', { cause: error });
  }
};

export const verifyCode = async ({ code, trustedDeviceId }: { code: string; trustedDeviceId?: string }): Promise<Response> => {
  const token = await updateToken();

  try {
    const res = await axios.post('/api/signin/mfa/verify-code', {
      code,
      trusted_device_id: trustedDeviceId,
      token,
    });
    return res.data;
  } catch (error) {
    // ネットワークエラーの場合
    if (!error.response) {
      throw new Error('ネットワークエラーが発生しました。インターネット接続を確認してください。', { cause: error });
    }

    throw new Error((error as AxiosError<Response>)?.response?.data?.message || '認証コードの検証に失敗しました。時間をおいて再度お試しください。', { cause: error });
  }
};
